module.exports = __webpack_public_path__ + "media/images/bank_images/bmg-f42c8ad8fcf568b9daf0e91b8b26c2b0.png";